export default {
  'landing.disclaimer':
    'To be able to use the Delta Team Dashboard, you need to be a Delta Direct partner.',
  'landing.apply': 'You can apply to join Delta Direct <0>here</0>.',
  'landing.trouble': 'Having trouble logging in? Please contact ',
  'landing.email': 'bizdev@delta.app',
  'landing.signin': 'Sign in with Twitter',
};
